import { IEnvironment } from './ienvironment';
export var environment:IEnvironment = {
  production: true,
  envName: 'preprod',
  VERSION: require('../../package.json').version,
  NAME: require('../../package.json').name,
};
